import { render } from "./shop-the-look.vue?vue&type=template&id=7f2b32e2"
import script from "./shop-the-look.vue?vue&type=script&lang=js"
export * from "./shop-the-look.vue?vue&type=script&lang=js"

import "./shop-the-look.vue?vue&type=style&index=0&id=7f2b32e2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__